<template>
  <el-dialog
    class="reverse-order-modal"
    width="90%"
    top="60px"
    title="申请反向单"
    v-loading="loading"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <div class="form">
      <div class="row">
        <div class="field col-sm-12">
          <label>买家:</label>
          <div>
            <el-autocomplete v-model="mobile" size="small" style="width: 220px" :fetch-suggestions="querySearchAsync" placeholder="请输入买方账户手机号/公司名称" @select="handleMobileSelect">
              <template slot-scope="{ item }">
                <div class="company">{{ item.companyName }}</div>
                <div class="passport">{{ item.userName }}<span v-if="item.displayName !== item.userName && item.displayName">({{ item.displayName }})</span></div>
              </template>
            </el-autocomplete>
          </div>
        </div>
        <div class="field col-sm-12">
          <label>收货地址:</label>
          <div>
            <address-selection :user="buyer" @select="onAddressSelected" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="field col-sm-12">
          <label>物流:</label>
          <div>
            <el-radio-group v-model="context.expressType">
              <el-radio label="物流快递">物流快递</el-radio>
              <el-radio label="到店自提">到店自提</el-radio>
              <el-radio label="送货上门">送货上门</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="field col-sm-12">
          <label>是否含税:</label>
          <div>
            <el-radio-group v-model="context.invoice" @change="setTaxed">
              <el-radio label="无需发票">去税</el-radio>
              <el-radio label="专用发票">含税</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="field col-sm-12">
          <label>发货:</label>
          <div>
            <el-radio-group v-model="context.isUnifiedDelivery">
              <el-radio :label="true">到齐发货</el-radio>
              <el-radio :label="false">先到先发</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="field col-sm-12">
          <label>清单:</label>
          <div>
            <el-radio-group v-model="context.isNeedList">
              <el-radio :label="true">要附清单</el-radio>
              <el-radio :label="false">不带清单</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="field col-sm-8">
          <label>方式:</label>
          <div>
            <el-radio-group v-model="createType" size="mini">
              <el-radio-button :label="1">模板上传</el-radio-button>
              <el-radio-button :label="2">手动创建</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="field col-sm-8">
          <el-checkbox v-model="context.isBatch">是否批量单</el-checkbox>
        </div>
        <div v-if="createType === 2" class="field col-sm-8">
          <label>折扣:</label>
          <div>
            <el-input-number id="discount-input" v-model="allDiscount" @change="handleAllDiscountChange" :min="0" :controls="false" :step="0.01" :step-strictly="true" :max="1" :precision="2" size="mini" />
          </div>
        </div>
      </div>
      <div v-if="createType === 1" class="field">
        <label></label>
        <div>
          <input ref="inputFile" type="file" style="display:none" multiple="false" accept=".xls,.xlsx,application/vnd.ms-excel,application/msexcel,application/x-msexcel,application/x-ms-excel,application/x-excel,application/x-dos_ms_excel,application/xls,application/x-xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="fileChange" />
          <el-button type="success" size="small" @click="fileSelect">{{ !file ? '选择文件' : '重新选择' }}</el-button>
          <a href="/template.xlsx" download="反向单模板.xlsx" style="margin-left: 8px;">下单模板下载</a>
        </div>
      </div>
      <div v-else class="manual-table">
        <div class="table-header">
          <div class="row" :style="{ paddingRight: hascroll ? scrollbarWidth + 'px' : '0px' }">
            <div class="col-sm-2 cell">类型</div>
            <div class="col-sm-2 cell">品牌</div>
            <div class="col-sm-3 cell">编号</div>
            <div class="col-sm-2 cell">名称</div>
            <div class="col-sm-2 cell">数量</div>
            <div class="col-sm-2 cell">品质</div>
            <div class="col-sm-2 cell">4S进价</div>
            <div class="col-sm-2 cell">单价</div>
            <div class="col-sm-1 cell">折扣</div>
            <div class="col-sm-2 cell">发货门店</div>
            <div class="col-sm-2 cell">库存抵扣</div>
            <div class="col-sm-2 cell">操作</div>
          </div>
        </div>
        <div ref="dataList" class="data-list" id="reverseOrderManualCreateTable">
          <div class="row" v-for="(part, idx) in partsManual" :key="idx">
            <div class="col-sm-2 cell">
              <label>类型</label>
              <div class="input">
                <el-select v-model="part.priceType" size="mini">
                  <el-option label="常规件" :value="0"></el-option>
                  <el-option label="急件" :value="1"></el-option>
                  <el-option label="海外件" :value="2"></el-option>
                  <el-option label="兆配现货" :value="3"></el-option>
                  <el-option label="4S现货" :value="4"></el-option>
                </el-select>
              </div>
            </div>
            <div class="col-sm-2 cell">
              <label>品牌</label>
              <div class="input">
                <el-select v-model="part.brandCode" size="mini" @change="queryPart(part)">
                  <el-option v-for="brand in brands" :key="brand.code" :value="brand.code" :label="brand.name" />
                </el-select>
              </div>
            </div>
            <div class="col-sm-3 cell">
              <label>编号</label>
              <div class="input">
                <el-input v-model="part.partCode" size="mini" @blur="queryPart(part)" />
              </div>
            </div>
            <div class="col-sm-2 cell">
              <label>名称</label>
              <div class="input">
                {{ part.partName || '--' }}
                <el-tooltip v-if="part.remark || part.replacementPartNo" :content="[part.remark, part.replacementPartNo].filter(t => t).join(' ')">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="col-sm-2 cell">
              <label>数量</label>
              <div class="input">
                <el-input-number v-model="part.quantity" :min="0" :controls="false" :step="1" :step-strictly="true" size="mini" />
              </div>
            </div>
            <div class="col-sm-2 cell">
              <label>品质</label>
              <div class="input">
                <el-select v-model="part.quality" size="mini">
                  <el-option label="原厂件" value="原厂件"></el-option>
                  <el-option label="残次件" value="残次件"></el-option>
                </el-select>
              </div>
            </div>
            <div class="col-sm-2 cell">
              <label>4S进价</label>
              <div class="input">
                {{ part.cost4s && part.cost4s.toFixed(2) || '--' }}
                <el-tooltip v-if="part.cost4s" :content="`价格更新时间：${dateFormat(part.priceUpdatedAt)}`">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="col-sm-2 cell">
              <label>单价</label>
              <div class="input">
                <el-input-number v-model="part.price" @change="rowPriceChange(part)" :min="0" :controls="false" :step="0.01" :step-strictly="true" size="mini" />
              </div>
            </div>
            <div class="col-sm-1 cell">
              <label>折扣</label>
              <div class="input">
                <el-input-number v-model="part.discount" @change="rowDiscountChange(part)" :min="0" :controls="false" :step="0.001" :step-strictly="true" size="mini" :max="10" />
              </div>
            </div>
            <div class="col-sm-2 cell">
              <label>发货门店</label>
              <div class="input">
                <el-select v-model="part.warehouse" size="mini">
                  <el-option
                    v-for="item in warehouses"
                    :key="item.name"
                    :value="item.name"
                    :label="item.name"
                  >
                    {{ item.name }}
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="col-sm-2 cell">
              <label>抵扣库存</label>
              <div class="input">
                <el-checkbox v-model="part.deductStock"></el-checkbox>
              </div>
            </div>
            <div class="col-sm-2 cell">
              <label>操作</label>
              <div class="input">
                <el-button :disabled="!(part.brandCode && part.partCode)" type="text" size="mini" @click="checkOfficial(part)">大库</el-button>
                <el-button type="text" size="mini" @click="doDel(idx)">删除</el-button>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 8px">
          <el-button type="success" size="mini" @click="handleAdd">增加</el-button>
        </div>
      </div>
      <div class="summary">
        <div v-if="parts && parts.length" class="inner-text">
          共{{ partsRow }}条记录，{{ totalCount }}件配件，总金额：{{ totalAmount }}
        </div>
        <div v-else-if="partsManual && partsManual.length" class="inner-text">
          共{{ partsRow }}条记录，{{ totalCount }}件配件，总金额：{{ totalAmount }}
        </div>
      </div>
      <div class="action-form">
        <el-button v-if="createType === 1" type="primary" size="small" @click="submit">确认</el-button>
        <el-button v-else type="primary" size="small" @click="submitManual">确认</el-button>
        <el-button type="default" size="small" @click="close">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import { CreateOrderApply, SearchBuyer, QueryPartCost4s, QueryOEMInfo } from '../services'
import AddressSelection from './AddressSelection.vue'
import { ExcelReader } from '@/libs/excelfile'
import moment from 'moment'
import _ from 'lodash'
export default {
  name: 'ReverseOrderApplyModal',
  mixins: [ ModalMixin ],
  components: { AddressSelection },
  data () {
    return {
      loading: false,
      hascroll: false,
      mobile: undefined,
      address: null,
      file: undefined,
      buyer: {
        companyId: undefined,
        passportId: undefined
      },
      scrollbarWidth: undefined,
      createType: 1,
      allDiscount: 1,
      context: {
        isBatch: false,
        isNeedList: true,
        isUnifiedDelivery: true,
        invoice: '专用发票',
        expressType: '物流快递'
      },
      parts: [],
      partsManual: [
        {
          priceType: 1,
          brandCode: '',
          partCode: '',
          cost4s: 0,
          price: 0,
          quantity: 1,
          partName: '',
          discount: 1,
          taxed: true,
          quality: '原厂件',
          warehouse: undefined,
          deductStock: true
        }
      ],
      schemas: [
        {
          code: 'priceType',
          name: '类型'
        },
        {
          code: 'brand',
          name: '品牌'
        },
        {
          code: 'partCode',
          name: '编号'
        },
        {
          code: 'partName',
          name: '名称'
        },
        {
          code: 'price4s',
          name: '4S进价'
        },
        {
          code: 'price',
          name: '售价'
        },
        {
          code: 'quantity',
          name: '数量'
        },
        {
          name: '是否含税',
          code: 'taxed'
        },
        {
          name: '品质',
          code: 'quality'
        },
        {
          code: 'warehouse',
          name: '发货门店'
        },
        {
          code: 'deductStock',
          name: '现货库存'
        }
      ]
    }
  },
  computed: {
    warehouses () {
      return (this.$store.state.shops || []).filter(w => !w.disabled).map(t => {
        return {
          id: t.id,
          name: t.name
        }
      })
    },
    brands () {
      return this.$store.state.orderBrands || []
    },
    partsRow () {
      if (this.createType === 1) {
        return this.parts.length
      } else {
        return this.partsManual.length
      }
    },
    totalAmount () {
      if (this.createType === 1) {
        return this.parts.reduce((p, c) => p + (+c.price) * (+c.quantity), 0)
      } else {
        return this.partsManual.reduce((p, c) => p + (+c.price) * (+c.quantity), 0)
      }
    },
    totalCount () {
      if (this.createType === 1) {
        return this.parts.reduce((p, c) => p + (+c.quantity), 0)
      } else {
        return this.partsManual.reduce((p, c) => p + (+c.quantity), 0)
      }
    },
    needTaxed () {
      return this.context.invoice === '专用发票'
    }
  },
  methods: {
    init () {
      this.getScrollbarWidth()
      if (!this.brands || !this.brands.length) {
        return this.$store.dispatch('loadOrderBrands').then(() => {
          return this.open()
        })
      } else {
        return this.open()
      }
    },
    setTaxed () {
      this.partsManual.forEach((part) => {
        part.taxed = this.context.invoice === '专用发票'
        if (part.taxed) {
          this.$set(part, 'price', +(part.cost4s * (part.discount || 0)).toFixed(2))
        } else {
          this.$set(part, 'price', +((part.cost4s * (part.discount || 0)) / 1.05).toFixed(2))
        }
      })
    },
    handleTaxToggle (part) {
      if (part.cost4s) {
        if (part.taxed) {
          this.$set(part, 'price', +(part.cost4s * (part.discount || 0)).toFixed(2))
        } else {
          this.$set(part, 'price', +((part.cost4s * (part.discount || 0)) / 1.05).toFixed(2))
        }
      }
    },
    dateFormat (val) {
      if (val) {
        const mt = moment(val)
        if (mt.isValid()) {
          return mt.format('YYYY/MM/DD')
        }
      }
      return '--'
    },
    getScrollbarWidth () {
      const odiv = document.createElement('div')
      const styles = {
        width: '30px',
        height: '30px',
        overflowY: 'scroll',
        position: 'absolute',
        top: 0,
        left: 0
      }
      let i
      for (i in styles) odiv.style[i] = styles[i]
      document.body.appendChild(odiv)
      const scrollbarWidth = odiv.offsetWidth - odiv.clientWidth
      odiv.remove()
      this.scrollbarWidth = scrollbarWidth
    },
    handleAllDiscountChange () {
      this.partsManual.forEach((item) => {
        const newPrice = +(Math.round(item.cost4s * this.allDiscount * (item.taxed ? 1 : 1 / 1.05) * 100) / 100).toFixed(2)
        this.$set(item, 'discount', this.allDiscount)
        this.$set(item, 'price', newPrice)
      })
    },
    rowPriceChange (part) {
      if (part.cost4s) {
        const newDiscount = +(part.price / (part.cost4s * (part.taxed ? 1 : 1 / 1.05))).toFixed(2)
        this.$set(part, 'discount', newDiscount)
      }
    },
    rowDiscountChange (part) {
      const newPrice = +(Math.round(part.cost4s * part.discount * (part.taxed ? 1 : 1 / 1.05) * 100) / 100).toFixed(2)
      this.$set(part, 'price', newPrice)
    },
    doDel (idx) {
      this.partsManual.splice(idx, 1)
      this.$nextTick(() => {
        this.checkScroll()
      })
    },
    handleAdd () {
      var lastOne = {
        priceType: 0,
        brandCode: '',
        partCode: '',
        cost4s: 0,
        price: 0,
        quantity: 1,
        partName: '',
        discount: 1,
        taxed: true,
        quality: '原厂件',
        warehouse: undefined,
        deductStock: true
      }
      if (this.partsManual && this.partsManual.length > 0) {
        const { priceType, brandCode, taxed, discount, warehouse, deductStock, quality } = this.partsManual[this.partsManual.length - 1]
        lastOne.priceType = priceType
        lastOne.brandCode = brandCode
        lastOne.taxed = taxed
        lastOne.quality = quality
        lastOne.discount = discount
        lastOne.warehouse = warehouse
        lastOne.deductStock = deductStock
      }
      this.partsManual.push(lastOne)
      this.$nextTick(() => {
        this.checkScroll()
      })
    },
    partCodeRegex (partCode) {
      return partCode.replace(/[^0-9a-zA-Z]/g, '').toLocaleUpperCase()
    },
    queryPart (part) {
      if (part.brandCode) {
        const brandName = this.brands.find(t => t.code === part.brandCode).name
        part.brandName = brandName
      }
      if (part.partCode) {
        const regCode = this.partCodeRegex(part.partCode)
        if (regCode !== part.partCode) {
          this.$set(part, 'partCode', regCode)
        }
      }
      if (!(part.brandCode && part.partCode)) {
        return
      }
      const toQuery = [
        {
          brandCode: part.brandCode,
          partCode: part.partCode,
          marketCode: part.brandCode === 'vw' ? 'CN' : (part.brandCode === 'honda') ? 'dongfeng' : ''
        }
      ]
      QueryPartCost4s(toQuery).then((resp) => {
        const priceList = resp || []
        if (priceList.length) {
          let queryOrg = priceList.find(t => t.partCode === part.partCode && t.brandCode === part.brandCode)
          if (queryOrg) {
            this.$set(part, 'partName', queryOrg.partName)
            this.$set(part, 'cost4s', queryOrg.cost)
            this.$set(part, 'price', +(queryOrg.cost * (part.discount || 0) * (part.taxed ? 1 : 1 / 1.05)).toFixed(2))
            this.$set(part, 'priceUpdatedAt', queryOrg.priceUpdatedAt)
            this.$set(part, 'replacementPartNo', queryOrg.replacementPartNo)
            this.$set(part, 'remark', queryOrg.remark)
          } else {
            queryOrg = priceList[0]
            this.$set(part, 'brandCode', queryOrg.brandCode)
            this.$set(part, 'partCode', queryOrg.partCode)
            this.$set(part, 'partName', queryOrg.partName)
            this.$set(part, 'replacementPartNo', queryOrg.replacementPartNo)
            this.$set(part, 'remark', queryOrg.remark)
            this.$set(part, 'cost4s', queryOrg.cost)
            this.$set(part, 'price', +(queryOrg.cost * (part.discount || 0) * (part.taxed ? 1 : 1 / 1.05)).toFixed(2))
            this.$set(part, 'priceUpdatedAt', queryOrg.priceUpdatedAt)
          }
        } else {
          this.$message.error('未查询到零件信息')
        }
      })
    },
    checkOfficial (part) { // 通过大库带出价格
      // if (part.brandCode === 'vw') {
      //   this.$message.error('抱歉，大众暂停原厂代订服务，后期启动我们将另行通知，感谢您的关注！')
      //   return
      // }

      const cb = res => {
        if (!res || !res.cost) {
          this.$message.error(res.partrCode + '未查询到大库信息')
          return
        }
        res.cost = res.cost || 0
        this.$set(part, 'cost4s', res.cost)
        this.$set(part, 'price', +(res.cost * (part.discount || 0) * (part.taxed ? 1 : 1 / 1.05)).toFixed(2))
        this.$set(part, 'minSell', res.ppq || 1)
        let remark = res.remark || ''
        this.$set(part, 'memo', remark)

        if (!part.partName) {
          this.$set(part, 'partName', res.partName)
        }

        let stockInfos = res.stockInfos
        try {
          stockInfos = JSON.parse(stockInfos) || []
        } catch (e) {
        }
        this.$set(part, 'priceUpdatedAt', res.priceUpdatedAt)
        this.$set(part, 'officialStock', res.stock)
        this.$set(part, 'officialStockDetail', stockInfos || [])
        this.modal('OfficalInfoModal', res)
      }
      QueryOEMInfo({
        brandCode: part.brandCode,
        partCode: part.partCode
      }).then(resp => {
        if (typeof (resp) === 'string') {
          cb(JSON.parse(resp))
        } else {
          cb(resp)
        }
      })
    },
    checkScroll () {
      const table = document.querySelector('#reverseOrderManualCreateTable')
      this.hascroll = table && (table.scrollHeight > table.clientHeight)
    },
    fileSelect () {
      this.$refs.inputFile.click()
    },
    fileChange () {
      if (this.$refs.inputFile.files && this.$refs.inputFile.files[0]) {
        this.file = this.$refs.inputFile.files[0]
        this.excelReader()
      } else {
        this.file = undefined
      }
    },
    excelReader () {
      this.loading = true
      ExcelReader(this.file).then((excelReadData) => {
        this.excelReadData = excelReadData
        excelReadData.ReadBook().then((sheetNames) => {
          if (sheetNames && ~sheetNames.indexOf('反向单模板')) {
            excelReadData.ReadSheet(sheetNames.indexOf('反向单模板')).then((data) => {
              const parts = []
              data.forEach((row, idx) => {
                if (idx === 0) {
                  this.schemas.forEach((col, idx) => {
                    if (row[idx] !== col.name) {
                      console.log(col.name, row[idx], idx)
                      throw new Error('请上传与模板一致的excel文件')
                    }
                  })
                } else {
                  const part = {}
                  this.schemas.forEach((col, idx) => {
                    part[col.code] = row[idx]
                  })
                  parts.push(part)
                }
              })
              this.parts = parts
              this.loading = false
            }).catch((err) => {
              console.log(err)
              this.$message.error('请上传与模板一致的excel文件')
              this.loading = false
            })
          } else {
            this.$message.error('请上传与模板一致的excel文件')
            this.loading = false
          }
        }).catch((err) => {
          console.log(err)
          this.$message.error('Excel数据读取失败')
          this.loading = false
        })
      }).catch((err) => {
        console.log(err)
        this.$message.error('Excel数据读取失败')
        this.loading = false
      })
    },
    onAddressSelected (val) {
      this.address = val
    },
    precossModel () {
      return new Promise((resolve, reject) => {
        try {
          const partsSub = []
          this.parts.forEach((part) => {
            const item = { ...part }
            if (item.priceType === '海外件') {
              item.priceType = 2
            } else if (item.priceType === '急件') {
              item.priceType = 1
            } else if (item.priceType === '兆配现货') {
              item.priceType = 3
            } else if (item.priceType === '4S现货') {
              item.priceType = 4
            } else {
              item.priceType = 0
            }
            item.quality = item.quality === '残次件' ? '残次件' : '原厂件'
            item.quantity = +item.quantity || 0
            item.isSupportReturn = false
            if (item.taxed === '是') {
              item.taxed = true
            } else {
              item.taxed = false
            }
            if (item.deductStock === '否') {
              item.deductStock = false
            } else {
              item.deductStock = true
            }
            partsSub.push(item)
          })
          const data = _.filter(partsSub, o => o.partCode && o.quantity && o.price && o.brandCode)
          resolve({ excelData: partsSub, data })
        } catch (err) {
          console.log(err)
          reject(new Error('数据格式有误'))
        }
      })
    },
    checkModel () {
      return new Promise((resolve, reject) => {
        if (!this.buyer.passportId || !this.buyer.companyId) {
          reject(new Error('请选择平台客户'))
        }
        if (!this.address || !(this.address.province && this.address.phone && this.address.name && this.address.city && this.address.area && this.address.details)) {
          reject(new Error('请选择收货地址信息'))
        }
        if (_.some(this.parts, o => !o.brand)) {
          reject(new Error('配件品牌是必选项'))
        }
        if (_.some(this.parts, o => !o.partCode)) {
          reject(new Error('配件编号是必选项'))
        }
        if (_.some(this.parts, o => !o.partName)) {
          reject(new Error('配件名称是必选项'))
        }
        if (_.some(this.parts, o => !o.quantity)) {
          reject(new Error('购买数量是必选项'))
        }
        if (_.some(this.parts, o => !o.price)) {
          reject(new Error('购买单价是必选项'))
        }
        if (_.some(this.parts, o => !o.price4s)) {
          reject(new Error('4S进价是必选项'))
        }
        if (_.some(this.parts, o => !o.taxed)) {
          reject(new Error('是否含税是必选项'))
        }
        if (_.some(this.parts, o => !o.warehouse)) {
          reject(new Error('发货门店是必选项'))
        }
        const partDict = {}
        this.parts.forEach((item) => {
          let brand = _.find(this.brands, o => o.name === item.brand)
          item.brandCode = (brand && brand.code) || ''
          item.brandName = (brand && brand.name) || item.brand
          const reg = new RegExp("[&nbsp; |' ']", 'g')
          item.partCode = item.partCode.replace(reg, '').trim()
          const rgx = /(\d|\.)/g
          if (typeof item.price4s !== 'number') {
            item.price4s = item.price4s ? +(item.price4s.match(rgx).join('')) : 0
          }
          if (typeof item.price !== 'number') {
            item.price = item.price ? +(item.price.match(rgx).join('')) : 0
          }
          const { partCode, brandCode } = item
          partDict[`${brandCode}_${partCode}`] = {
            brandCode,
            partCode,
            marketCode: ''
          }
        })
        const toQuery = []
        for (let partKey in partDict) {
          toQuery.push(partDict[partKey])
        }
        if (toQuery && toQuery.length) {
          QueryPartCost4s(toQuery).then((resp) => {
            const priceList = resp || []
            const errorPartsList = []
            const outDatePartList = []
            const nonePartsList = []
            if (priceList.length) {
              this.parts.forEach((p) => {
                const price = _.find(priceList, o => o.brandCode === p.brandCode && o.partCode === p.partCode && o.cost)
                if (!price) {
                  nonePartsList.push(p.partCode)
                } else {
                  const priceDateDiff = new Date().getTime() - moment(price.priceUpdatedAt).toDate().getTime()
                  if (priceDateDiff > 3 * 86400000 && ['porsche', 'honda'].indexOf(p.brandCode) === -1) {
                    // 保时捷 本田 价格更新慢 不校验3天时间
                    outDatePartList.push(p.partCode)
                  } else if (Math.abs(price.cost - p.price4s) >= 1) {
                    p.price4sNew = price.cost
                    errorPartsList.push(p.partCode)
                  }
                }
              })
            } else {
              reject(new Error('未查到大库信息'))
            }
            if (outDatePartList.length) {
              reject(new Error(`${outDatePartList.join('\r\n')}等校验价格更新时间超过3天`))
            } else if (nonePartsList.length) {
              reject(new Error(`${nonePartsList.join('\r\n')}未查到大库信息`))
            } else if (errorPartsList.length) {
              reject(new Error(`${errorPartsList.join('\r\n')}4s进价不对`))
            } else {
              resolve(true)
            }
          }).catch((err) => {
            reject(err)
          })
        } else {
          reject(new Error('无有效数据行'))
        }
      })
    },
    checkModelManual () {
      return new Promise((resolve, reject) => {
        if (!this.buyer.passportId || !this.buyer.companyId) {
          reject(new Error('请选择平台客户'))
        }
        if (!this.address || !(this.address.province && this.address.phone && this.address.name && this.address.city && this.address.area && this.address.details)) {
          reject(new Error('请选择收货地址信息'))
        }
        if (_.some(this.partsManual, o => !o.brandCode)) {
          reject(new Error('配件品牌是必选项'))
        }
        if (_.some(this.partsManual, o => !o.partCode)) {
          reject(new Error('配件编号是必选项'))
        }
        if (_.some(this.partsManual, o => !o.partName)) {
          reject(new Error('配件名称是必选项'))
        }
        if (_.some(this.partsManual, o => !o.quantity)) {
          reject(new Error('购买数量是必选项'))
        }
        if (_.some(this.partsManual, o => !o.price)) {
          reject(new Error('购买单价是必选项'))
        }
        if (_.some(this.partsManual, o => !o.cost4s)) {
          reject(new Error('4S进价是必选项'))
        }
        if (_.some(this.partsManual, o => !o.warehouse)) {
          reject(new Error('发货门店是必选项'))
        }
        if (_.some(this.partsManual, o => (new Date().getTime() - moment(o.priceUpdatedAt).toDate().getTime()) > 86400000 * 3 && ['porsche', 'honda'].indexOf(o.brandCode) === -1)) {
          // 本田 保时捷 价格更新较慢 不校验3天时间
          const outDateParts = _.filter(this.partsManual, o => (new Date().getTime() - moment(o.priceUpdatedAt).toDate().getTime()) > 86400000 * 3 && ['porsche', 'honda'].indexOf(o.brandCode) === -1)
          reject(new Error(`${outDateParts.map(t => t.partCode).join()}等配件价格过旧`))
        }
        resolve(true)
      })
    },
    submit () {
      this.loading = true
      this.checkModel().then(() => {
        const that = this
        this.precossModel().then((rst) => {
          this.$confirm(`Excel共计${rst.excelData.length}条记录，筛选出${rst.data.length}条可上传记录`, '确认', {
            type: 'warning'
          }).then(() => {
            if (rst.data && rst.data.length) {
              const orderItemsMap = _.groupBy(rst.data, o => `${o.brandCode}_${o.partCode}_${o.priceType}_${o.taxed ? '1' : '0'}_${o.price}`)
              const orderItems = []
              for (let prop in orderItemsMap) {
                const { priceType, partCode, partName, quality, memo, price, price4s, brandName, brandCode, isSupportReturn, taxed, warehouse, deductStock } = orderItemsMap[prop][0]
                const quantity = orderItemsMap[prop].reduce((s, c) => s + c.quantity, 0)
                orderItems.push({
                  id: 0,
                  priceType,
                  partCode,
                  partName,
                  quality,
                  memo: memo || '',
                  price,
                  price4s,
                  brandName,
                  brandCode,
                  supportReturn: isSupportReturn,
                  taxed,
                  quantity,
                  warehouse,
                  deductStock
                })
              }
              const toPost = {
                from: 6, // 兆配云反向
                customerId: that.buyer.passportId,
                companyId: that.buyer.companyId,
                companyName: that.buyer.companyName,
                addresseeInfo: {
                  phone: that.address.phone,
                  name: that.address.name,
                  address: `${that.address.province}-${that.address.city}-${that.address.area} ${that.address.details}`
                },
                isUnifiedDelivery: that.context.isUnifiedDelivery,
                isNeedList: that.context.isNeedList,
                isBatch: that.context.isBatch,
                orderList: [
                  {
                    partFrom: 7,
                    invoice: that.context.invoice,
                    express: that.context.expressType,
                    memo: '',
                    items: orderItems
                  }
                ]
              }
              CreateOrderApply(toPost).then(() => {
                that.$message.success('反向单审批创建成功，等待审批')
                that.close(true)
              }).catch((err) => {
                console.log(err)
                that.$message.error('Service Error')
              }).finally(() => {
                this.loading = false
              })
            }
          }).catch(() => {
            this.loading = false
          })
        }).catch((err) => {
          this.$message.error(err.message)
        })
      }).catch((err) => {
        this.loading = false
        this.$message.error(err.message)
      })
    },
    submitManual () {
      const that = this
      this.checkModelManual().then(() => {
        if (that.partsManual && that.partsManual.length) {
          this.$confirm(`共计${that.partsManual.length}条,${that.partsManual.reduce((p, c) => p + c.quantity, 0)}个配件，总金额${that.partsManual.reduce((p, c) => p + c.quantity * c.price, 0)}`, '确认', {
            type: 'warning'
          }).then(() => {
            const orderItemsMap = _.groupBy(that.partsManual, o => `${o.brandCode}_${o.partCode}_${o.priceType}_${o.taxed ? '1' : '0'}_${o.price}`)
            const orderItems = []
            for (let prop in orderItemsMap) {
              const { priceType, partCode, partName, price, cost4s, brandName, brandCode, taxed, warehouse, deductStock, remark, replacementPartNo, quality } = orderItemsMap[prop][0]
              const quantity = orderItemsMap[prop].reduce((s, c) => s + c.quantity, 0)
              orderItems.push({
                id: 0,
                priceType,
                partCode,
                partName,
                quality,
                memo: [remark, replacementPartNo].filter(t => t).join(' '),
                price,
                price4s: cost4s,
                brandName,
                brandCode,
                supportReturn: false,
                taxed,
                quantity,
                warehouse,
                deductStock
              })
            }
            const toPost = {
              from: 6, // 兆配云反向
              customerId: that.buyer.passportId,
              companyId: that.buyer.companyId,
              companyName: that.buyer.companyName,
              addresseeInfo: {
                phone: that.address.phone,
                name: that.address.name,
                address: `${that.address.province}-${that.address.city}-${that.address.area} ${that.address.details}`
              },
              isUnifiedDelivery: that.context.isUnifiedDelivery,
              isNeedList: that.context.isNeedList,
              isBatch: that.context.isBatch,
              orderList: [
                {
                  partFrom: 7,
                  invoice: that.context.invoice,
                  express: that.context.expressType,
                  memo: '',
                  items: orderItems
                }
              ]
            }
            CreateOrderApply(toPost).then(() => {
              that.$message.success('反向单审批创建成功，等待审批')
              that.close(true)
            }).catch((err) => {
              console.log(err)
              that.$message.error('Service Error')
            }).finally(() => {
              this.loading = false
            })
          })
        }
      }).catch((err) => {
        this.$message.error(err.message)
      })
    },
    querySearchAsync (queryString, cb) {
      this.buyer = {}
      if (queryString) {
        SearchBuyer(queryString).then((resp) => {
          cb(resp)
        })
      } else {
        // eslint-disable-next-line standard/no-callback-literal
        cb([])
      }
    },
    handleMobileSelect (val) {
      this.mobile = val.userName
      this.buyer = val
    }
  }
}
</script>
<style lang="stylus">
.reverse-order-modal
  .el-dialog
    max-width 1240px
    .el-dialog__body
      padding-top 0
      overflow-x hidden
      overflow-y auto
    .form
      .field
        display: flex
        flex-direction: row
        margin-bottom: 6px
        >label
          font-weight: bold
          line-height: 32px
          width: 70px
          text-align: right
          flex-shrink: 0
          margin-right: 8px
        >div
          line-height 32px
        .address-selection
          ul
            max-height 120px
            overflow-y: auto
            margin: 0
            padding: 0
            li
              padding: 0
      .summary
        margin-top 16px
        .inner-text
          line-height 1.4
          padding 8px
          background #EF7910
          color: #ffffff
      .action-form
        margin-top: 16px
        padding-left: 76px
.el-autocomplete-suggestion
  li
    line-height 1.2
    padding: 6px 10px
    .passport
      color #999999
.manual-table
  border-top: 1px dashed #F6B41C
  border-bottom: 1px dashed #F6B41C
  padding 8px 0
  .table-header
    border-top 1px solid #d4d4d4
    border-right 1px solid #d4d4d4
    border-bottom 1px solid #d4d4d4
    .row
      display: flex
      flex-direction row
      flex-wrap nowrap
      .cell
        border-left 1px solid #d4d4d4
        padding: 2px
        text-align center
  .data-list
    border-right 1px solid #d4d4d4
    max-height 240px
    overflow-x hidden
    overflow-y auto
    .row
      display: flex
      flex-direction row
      flex-wrap nowrap
      .cell
        border-left 1px solid #d4d4d4
        border-bottom 1px solid #d4d4d4
        padding: 2px
        text-align center
        overflow: hidden
        height 32px
        line-height 24px
        position: relative
        .input
          display inline-block
        .el-input-number
          width: auto
          &.is-without-controls
            .el-input__inner
              padding-left 0
              padding-right 0
        >label
          display:none
@media screen and (max-width: 768px)
  .manual-table
    .table-header
      display: none
    .data-list
      border none
      .row
        display: inline-block
        border 1px solid #d4d4d4
        width 100%
        .cell
          border none
          text-align left
          >label
            display: inline-block
            width: 80px
            text-align right
            &:after
              content: '\ff1a'
        +.row
          margin-top 8px
</style>
